import { fetchData } from "./client";
import { requestAutomationSurveyPromptCheck } from "../utils/automationSurveyPromptBus";

export async function previewMergeRequests(ids) {
  const res = await fetchData("/requests/merge/preview", "POST", { ids });
  return res?.data ?? res;
}

export async function commitMergeRequests(payload) {
  const res = await fetchData("/requests/merge/commit", "POST", payload);
  return res?.data ?? res;
}

export async function bulkUpdateRequests(ids, patch = {}) {
  const payload = { ids, ...patch };
  const list = Array.isArray(ids) ? ids : [];
  const bulkTimeoutMs = Math.min(300000, 45000 + list.length * 2500);
  const res = await fetchData("/requests/bulk/status", "POST", payload, { timeout: bulkTimeoutMs });
  if (list.length) {
    window.setTimeout(() => {
      list.forEach((id) => requestAutomationSurveyPromptCheck(id));
    }, 200);
  }
  return res?.data ?? res;
}

/** @deprecated Use bulkUpdateRequests */
export async function bulkUpdateRequestsStatus(ids, status) {
  return bulkUpdateRequests(ids, { status });
}

export async function bulkDistributeRequests(ids, userIds) {
  const list = Array.isArray(ids) ? ids : [];
  const bulkTimeoutMs = Math.min(300000, 45000 + list.length * 2500);
  const res = await fetchData("/requests/bulk/distribute", "POST", { ids, userIds }, { timeout: bulkTimeoutMs });
  return res?.data ?? res;
}
